import React, { memo } from 'react';
import { useSearchParams } from 'react-router-dom';

import DefaultButton from 'components/atoms/DefaultButton';
import { SEARCH_PARAMS } from 'constants/search-params';
import { useMyUserHasInternalPermission } from 'store/modules/myUser/hooks';
import { ProtectedResource, ResourceAction } from 'types/action.enum';

function BackOfficeEnterpriseCreateButton(): JSX.Element | null {
  const hasPermission = useMyUserHasInternalPermission({
    resource: ProtectedResource.ENTERPRISE,
    action: ResourceAction.ADD
  });
  const [, setSearchParams] = useSearchParams();

  if (!hasPermission) return null;

  const handleClick = () => {
    setSearchParams((prev) => {
      const newSearchParams = new URLSearchParams(prev);
      newSearchParams.delete(SEARCH_PARAMS.BACK_OFFICE.SELECTED_ENTERPRISE);
      newSearchParams.set(SEARCH_PARAMS.DRAWER.key, SEARCH_PARAMS.DRAWER.values.ADD_ENTERPRISE);
      return newSearchParams;
    });
  };

  return (
    <DefaultButton
      id="add-enterprise-button"
      type="primary"
      size="small"
      onClick={handleClick}
      mobileChildren="ADD"
    >
      ADD ENTERPRISE
    </DefaultButton>
  );
}

export default memo(BackOfficeEnterpriseCreateButton);
